import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyExpense = Loadable({
    loader: () => import("pages/Cashflow/Expense/index"),
    loading: () => <PageLoader />,
});

const LazyDepreciation = Loadable({
    loader: () => import("pages/Cashflow/DepreciationAsset/index"),
    loading: () => <PageLoader />,
});

const LazyRevenueBusiness = Loadable({
    loader: () => import("pages/Cashflow/RevenueBusiness/index"),
    loading: () => <PageLoader />,
});

const LazyRevenueCustomer = Loadable({
    loader: () => import("pages/Cashflow/RevenueCustomer/index"),
    loading: () => <PageLoader />,
});

const LazyRecapRevenueCustomer = Loadable({
    loader: () => import("pages/Cashflow/RecapRevenueCustomer/index"),
    loading: () => <PageLoader />,
});

const LazyMonthlyCashflowReport = Loadable({
    loader: () => import("pages/Cashflow/MonthlyCashflow/index"),
    loading: () => <PageLoader />,
});

const LazyFinancialReport = Loadable({
    loader: () => import("pages/Cashflow/FinancialReport/index"),
    loading: () => <PageLoader />,
});

const LazyProfitLoss = Loadable({
    loader: () => import("pages/Cashflow/ProfitLoss/index"),
    loading: () => <PageLoader />,
});

// const LazyOrderDetail = Loadable({
//     loader: () => import("pages/OrderDetail/index"),
//     loading: () => <PageLoader />,
// });


function CashflowRoute() {
    return (
        <Routes>
            <Route path="/expense" element={<LazyExpense />} />
            <Route path="/depreciation" element={<LazyDepreciation />} />
            <Route path="/business-to-business" element={<LazyRevenueBusiness />} />
            <Route path="/business-to-customer" element={<LazyRevenueCustomer />} />
            <Route path="/recap-revenue-customer" element={<LazyRecapRevenueCustomer />} />
            <Route path="/monthly-report" element={<LazyMonthlyCashflowReport />} />
            <Route path="/financial-report" element={<LazyFinancialReport />} />
            <Route path="/profit-loss" element={<LazyProfitLoss />} />
        </Routes>
    );
}

export default CashflowRoute;
